module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/why-pict-5a0c9489faff1dba5a359d8e594517ed.jpg";